import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    aux: {
      mainGuest: true,
      transfer: false,
      discount: 0
    },
    language: 'pt_BR', // language datepicker
    subtotalReservation: 0.0, // subtotal reservation
    totalReservation: 0.0, // total reservation
    bedroomsAvailable: [], // bedrooms availables
    dateReservation: { // date and quantity peoples
      checkin: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ),
      checkout: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()+2
      ),
      adulto: 1,
      crianca: 0
    },
    dateDisabled: { // desabled dates
      disabledDatesCheckIn: {
        to: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()
        ),
      },
      disabledDatesCheckOut: {
        to: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()+2
        ),
      },
    },

    client: { // data client
      name: '',
      nickname: '',
      email: '',
      phone: [],
      age: 18,
      password: '',
      address: [{
        street: '',
        number: '',
        city: '',
        neighborhood: '',
        country: 'Brazil'
      }]
    },
    dataReservation: { // data reservation
      bedroomsSelected: [ ],
      bedroomsRequested: [ ],
      client: { id: "" },
      guest: { id: "" },
      coupon: { code: "" },
      begin: '',
      end: '',
      specialRequest: '',
      transfer: {
        airport: {
          name: '',
          city: '',
          arrivalDate: new Date(),
        }
      },
      cardPayment: {
        cardNumber: '', // '4073877413037644',
        cvvNumber: '', // '123',
        dateValid: new Date()
      }
    },

    bedroomsGroupByType: []
  },
  mutations: {
    
    setBedroomsAvailable(state, data) {
      state.bedroomsAvailable = data
      // console.log("STORE:", JSON.stringify(data))
    },
    selectLanguage(state, language) {
      state.language = language
    },

    addBedroom(state, data) { // adiciona um quarto no carrinho
      // { id: item.id, name: item.name, bedroom: item.data }
      state.dataReservation.bedroomsSelected.push(data)

      state.subtotalReservation += data.value
      state.subtotalReservation = parseFloat(state.subtotalReservation)
      state.totalReservation = parseFloat((state.subtotalReservation * state.dateReservation.qtdDias)) 
    },
    rmBedroom(state, data) { // remove um quarto do carrinho
      let id = state.dataReservation.bedroomsSelected.lastIndexOf(data)
      state.dataReservation.bedroomsSelected.splice(id, 1)

      state.subtotalReservation -= data.value
      state.subtotalReservation = parseFloat(state.subtotalReservation)
      state.totalReservation = parseFloat((state.subtotalReservation * state.dateReservation.qtdDias)) 
    },
    addBedroomRequested(state, data){
      state.dataReservation.bedroomsRequested = [ ...data ]
      state.dataReservation.bedroomsSelected = []
      // console.log(state.dataReservation.bedroomsRequested)
    },

    setHourAirport(state, data) {
      state.dataReservation.transfer.airport.arrivalDate = new Date(state.dataReservation.begin)
      state.dataReservation.transfer.airport.arrivalDate.setHours(data.hour)
      state.dataReservation.transfer.airport.arrivalDate.setMinutes(data.minute)
    },

    setReservation(state, data) { // guarda o estado de checkin, checkout e qtds
      state.dateReservation.checkin = data.checkin
      state.dateReservation.checkout = data.checkout
      state.dateReservation.quarto = data.quarto
      state.dateReservation.adulto = data.adulto
      state.dateReservation.crianca = data.crianca
      state.totalReservation = state.subtotalReservation * state.dateReservation.qtdDias

      state.dataReservation.begin = state.dateReservation.checkin
      state.dataReservation.end = state.dateReservation.checkout
    },
    setDateValidCard(state, data) {
      // guarda a validade do cartão de crédito
      if(data.uni == 'month')
        state.dataReservation.cardPayment.dateValid.setMonth(data.value)
      else
        state.dataReservation.cardPayment.dateValid.setFullYear(data.value)
    },
    setCoupon(state, data) {
      state.dataReservation.coupon = data.coupon
      state.aux.discount = data.discount
    },

    setQtdDias(state, data) {
      state.dateReservation.qtdDias = data
      state.totalReservation = state.subtotalReservation * state.dateReservation.qtdDias
    },
    setDisabledDatesCheckout(state, data){
      // desabilita as datas a partir de checkin e checkout
      state.dateDisabled.disabledDatesCheckOut.to = data
    },

    setBedroomsGroupByType(state, data) {
      state.bedroomsGroupByType = data
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js